import HttpClientV2 from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/utils/HttpClientV2";

class LazoCustomAuthControllerV2Service {
  path: string;

  constructor(path: string) {
    this.path = path;
  }

  forgotPassword(email: string) {
    return HttpClientV2.post(`${this.path}/forgot-password`, { email });
  }
}

export default new LazoCustomAuthControllerV2Service("/auth");
